var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Col class=\"step-nav\"\u003E\u003Cli ng-repeat=\"step in vm.steps\" ng-class=\"vm.getClass($index)\"\u003E{{step.title}}\u003C\u002Fli\u003E\u003C\u002Fol\u003E";;return pug_html;};
module.exports = template;